import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_QUERYURL } from '../components/constants';

export const fetchQAHistory = createAsyncThunk(
  'qaHistory/fetchQAHistory',
  async ({ historyId, userId, taskId }) => {
    try {
      const response = await fetch(
        `${BASE_QUERYURL}/question-history?history_id=${historyId}&user_id=${userId}&task_id=${taskId}`
      );
      if (!response.ok) {
        throw new Error('Failed to fetch QA history');
      }
      const data = await response.json();

      console.log(data,'data History')
      return data.qa_pairs;
    } catch (error) {
      throw error;
    }
  }
);

const qaHistorySlice = createSlice({
  name: 'qaHistory',
  initialState: {
    qaHistory: [],
    loading: false,
    error: null,
    historyLoaded: false
  },
  reducers: {
    clearQAHistory: (state) => {
      state.qaHistory = [];
      state.historyLoaded = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQAHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQAHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.qaHistory = action.payload.map(message => ({
          id: message.id,
          role: message.role,
          comment: message.comment || '',
          content: message.content,
          sources: message.sources || [],
          timestamp: message.timestamp,
          title: message.title || ''
        }));
        state.historyLoaded = true;
      })
      .addCase(fetchQAHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export const { clearQAHistory } = qaHistorySlice.actions;
export default qaHistorySlice.reducer; 